export default __webpack_public_path__ + "static/media/data.47231b89.svg";